import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { S as SecondaryView } from '../SecondaryView/SecondaryView-CH9uAO5h.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { R as RadioGroupProvider } from '../RadioGroup/RadioGroupContext-DsoCoIZR.js';
import { D as DropdownDivider } from './DropdownDivider-B9zr96lo.js';
import { w as withTaktFallbackId } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { s as scrollIntoBounds } from '../LocalModules/storm-ui-utils/dist/esm/scrollIntoBounds/scrollIntoBounds-Dhl2O567-Dhl2O567.js';

const DropdownSecondaryView = withTaktFallbackId(SecondaryView);
const ContentHeader = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1glfm6m-0"
})(["background:", ";padding:", ";text-align:start;border:none;border-bottom:1px solid ", ";", ""], ({
  theme
}) => theme.palette.white, ({
  theme
}) => theme.spacing.mini, ({
  theme
}) => theme.palette.mercury, isMobile(css(["padding:", ";"], ({
  theme
}) => theme.mobile.spacing.mini)));
const ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1glfm6m-1"
})(["height:100%;display:flex;flex-direction:column;& fieldset{background-color:", ";}"], ({
  theme
}) => theme.palette.white);
const ScrollContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1glfm6m-2"
})(["padding:10px;flex:1;overflow:auto;& > label{background-color:", ";border:none;border-radius:0;border:", " solid ", ";border-top:0;}& > label:first-of-type{border-top-left-radius:", ";border-top-right-radius:", ";border-top:", " solid ", ";}& > label:last-of-type{border-bottom-left-radius:", ";border-bottom-right-radius:", ";}& > ", "{border:none;}", ""], ({
  theme
}) => theme.form.radio.mobile.backgroundColor, ({
  theme
}) => theme.form.radio.mobile.buttonBorderWidth, ({
  theme
}) => theme.form.radio.mobile.buttonBorderColor, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, ({
  theme
}) => theme.form.radio.mobile.buttonBorderWidth, ({
  theme
}) => theme.form.radio.mobile.buttonBorderColor, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, DropdownDivider, isMobile(css(["& > fieldset:not(:first-of-type){margin-block-start:", ";}"], ({
  theme
}) => theme.mobile.spacing.mini)));
const ScrollWrapper = props => {
  const radioGroupWrapperRef = useRef(null);
  useEffect(() => {
    if (radioGroupWrapperRef.current) {
      var _radioGroupWrapperRef;
      scrollIntoBounds(radioGroupWrapperRef.current, (_radioGroupWrapperRef = radioGroupWrapperRef.current) === null || _radioGroupWrapperRef === void 0 ? void 0 : _radioGroupWrapperRef.querySelector('input[type="radio"]:checked'));
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(ScrollContainer, _extends({
    role: "listbox",
    ref: radioGroupWrapperRef
  }, props));
};
const MobileContainer = ({
  isOpen,
  onClose,
  secondaryViewCloseButtonLabel,
  children,
  trigger,
  anchorEl,
  preRender,
  postRender,
  name,
  onChange,
  selectedValue
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DropdownSecondaryView, {
  isOpen: isOpen,
  onClose: onClose,
  toggleEl: anchorEl,
  padding: "none",
  closeButtonLabel: secondaryViewCloseButtonLabel,
  taktFallbackId: "dropdown-mobile"
}, /*#__PURE__*/React__default.createElement(ContentWrapper, null, preRender && /*#__PURE__*/React__default.createElement(ContentHeader, null, preRender()), /*#__PURE__*/React__default.createElement(ScrollWrapper, null, /*#__PURE__*/React__default.createElement(RadioGroupProvider, {
  name: name,
  selectedValue: selectedValue,
  handleRadioChange: (event, value) => {
    onChange(value, event);
  }
}, children), postRender === null || postRender === void 0 ? void 0 : postRender()))), trigger());
MobileContainer.defaultProps = {
  selectedValue: undefined,
  preRender: undefined,
  postRender: undefined
};

export { MobileContainer as M };
//# sourceMappingURL=DropdownMobileContainer-wYqw5Yjd.js.map
